import Page, { BlocksPipes, Galleries, BlocksHtml } from '../../../../common/types/api/page'
import { WidgetTypes } from '../../../../common/types/api/report'
import { WidgetPage } from '../types'
import { removeInvalidWidgets } from './removeInvalidWidgets'

export function updateWidgetPage(id: number, widget: WidgetPage, page: Page): Page {
    switch (widget.type) {
        case WidgetTypes.PIPES:
            return {
                ...page,
                blocksPipes: page.blocksPipes.map(block => (block.id === id ? (widget.config as BlocksPipes) : block))
            }
        case WidgetTypes.HTML:
            return {
                ...page,
                blocksHtml: page.blocksHtml.map(block => (block.id === id ? (widget.config as BlocksHtml) : block))
            }

        case WidgetTypes.GALLERY: {
            const newGallery = {
                ...page,
                galleries: page.galleries
                    .map(block => (block.id === id ? (widget.config as Galleries) : block))
                    .filter(g => Array.isArray(g.columns) && g?.columns && g?.columns?.length > 0)
                    .reduce((galleriesResult, currentGallerie) => {
                        currentGallerie.columns = removeInvalidWidgets(currentGallerie.columns)
                        galleriesResult.push(currentGallerie)

                        return galleriesResult
                    }, [] as Galleries[])
            }

            // filtering invalid widgets
            return newGallery
        }
    }
}
